export const cardPaymentLocationBased = {
  one: () => ['cardPaymentLocationBased'] as const
}

export const bankPaymentLocationBased = {
  one: () => ['bankPaymentLocationBased'] as const,
  complete: () => ['completeBankPaymentLocationBased'] as const
}
